import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// CC-Common imports
import { CCCommonModule, CCDataGridFeaturesModule } from 'cc-common';

import { AngularSplitModule } from 'angular-split';

// devetreme module imports
import {
    DxBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxListModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxPopoverModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSelectBoxModule,
    DxTabPanelModule,
    DxTabsModule,
    DxTemplateModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidatorModule,
    DxContextMenuModule,
    DxFileUploaderModule,
    DxCheckBoxModule,
    DxSwitchModule,
    DxTreeListModule
} from 'devextreme-angular';
import { SharedModule } from '../../shared-module/shared.module';
import { ManagementCommonModule } from '../../management-common/management-common.module';
import { SharedWorkflowModule } from '../../shared-workflow-module/shared-workflow.module';

// component imports
import { TransactionHistoryComponent } from './common/transaction-history/transaction-history.component';
import { ARInvoiceDetailsComponent } from './account-receivable/invoice-details/ar-invoice-details.component';
import { WaiveInvoiceConfirmationComponent } from './account-receivable/invoice-details/waive-invoice-confirmation/waive-invoice-confirmation.component';
import { AddressEditorComponent } from './common/address-editor/address-editor.component';
import { APBillDetailComponent } from './accounts-payable/ap-bill-detail/ap-bill-detail.component';
import { ARAdjustmentComponent } from './account-receivable/ar-adjustment/ar-adjustment.component';
import { TransactionAttachmentsComponent } from './common/transaction-attachments/transaction-attachments.component';
import { APPaymentDetailsComponent } from './accounts-payable/ap-payment-detail/ap-payment-details.component';
import { APAdjustmentComponent } from './accounts-payable/ap-adjustment/ap-adjustment.component';
import { CashReceiptDetailsComponent } from './cash-management/cash-receipt-details/cash-receipt-details.component';
import { CashReceiptsEditorComponent } from './cash-management/cash-receipts-editor/cash-receipts-editor.component';
import { CashReceiptReverseEditorComponent } from './cash-management/cash-receipt-reverse-editor/cash-receipt-reverse-editor.component';
import { DepositDetailsComponent } from './cash-management/deposit-details/deposit-details.component';
import { CBBatchDetailsComponent } from './cb-batch-details/cb-batch-details.component';
import { ARPaymentDetailsComponent } from './account-receivable/ar-payment-detail/ar-payment-details.component';
import { ARPaymentTransferHistoryComponent } from './account-receivable/ar-payment-detail/ar-payment-transfer-history/ar-payment-transfer-history.component';
import { DetailPopupsComponent } from './detail-popups/detail-popups.component';
import { ApplyVendorCreditsComponent } from './accounts-payable/apply-vendor-credits/apply-vendor-credits.component';
import { ChangeSpecialHandlingComponent } from './accounts-payable/change-special-handling/change-special-handling.component';
import { ARCreditApplicationComponent } from './account-receivable/ar-credit-application/ar-credit-application.component';
import { ARPaymentReverseEditorComponent } from './account-receivable/ar-payment-detail/ar-payment-reverse-editor/ar-payment-reverse-editor.component';
import { ARPaymentEditorComponent } from './account-receivable/ar-payment-detail/ar-payment-editor/ar-payment-editor.component';
import { ARPaymentTransferEditorComponent } from './account-receivable/ar-payment-detail/ar-payment-transfer-editor/ar-payment-transfer-editor.component';
import { AddTransferAccountComponent } from './account-receivable/ar-payment-detail/add-transfer-account/add-transfer-account.component';
import { IssueRefundPaymentEditorComponent } from './account-receivable/ar-payment-detail/issue-refund-payment-editor/issue-refund-payment-editor.component';
import { VoidAPPaymentComponent } from './common/void-ap-payment/void-ap-payment.component';
import { APPaymentPostDateEditorComponent } from './common/ap-payment-post-date-editor/ap-payment-post-date-editor.component';
import { APAdjustmentEditorComponent } from './accounts-payable/ap-adjustment-editor/ap-adjustment-editor.component';
import { AccountSelectorComponent } from './common/account-selector/account-selector.component';
import { ChangeVendorComponent } from './accounts-payable/change-vendor/change-vendor.component';
import { JournalEntryDetailComponent } from './general-ledger/journal-entry-detail/journal-entry-detail.component';
import { WriteOffInvoiceConfirmationComponent } from './account-receivable/invoice-details/write-off-invoice-confirmation/write-off-invoice-confirmation.component';
import { ARInvoiceReverseEditorComponent } from './account-receivable/invoice-details/ar-invoice-reverse-editor/ar-invoice-reverse-editor.component';
import { ARAdjustmentReverseEditorComponent } from './account-receivable/ar-adjustment/ar-adjustment-reverse-editor/ar-adjustment-reverse-editor.component';
import { ARAdjustmentWriteOffEditorComponent } from './account-receivable/ar-adjustment/ar-adjustment-write-off-editor/ar-adjustment-write-off-editor.component';
import { ARMiscInvoiceEditorComponent } from './account-receivable/ar-misc-invoice-editor/ar-misc-invoice-editor.component';
import { ARInvoiceEditorComponent } from './account-receivable/ar-invoice-editor/ar-invoice-editor.component';
import { ServiceChargeEditorComponent } from './accounts-payable/service-charge-editor/service-charge-editor.component';
import { ARManualLineItemCreditApplicationComponent } from './account-receivable/ar-manual-credit-application/ar-manual-line-item-credit-application/ar-manual-line-item-credit-application.component';
import { ARManualCreditApplicationComponent } from './account-receivable/ar-manual-credit-application/ar-manual-credit-application.component';
import { APReverseComponent } from './accounts-payable/ap-reverse/ap-reverse.component';
import { ARAdjustmentEditorComponent } from './account-receivable/ar-adjustment/ar-adjustment-editor/ar-adjustment-editor.component';
import { APCreditApplicationComponent } from './accounts-payable/ap-credit-application/ap-credit-application.component';
import { ApplyAdjustmentDebitComponent } from './accounts-payable/apply-adjustment-debit/apply-adjustment-debit.component';
import { ApplyDebitLineItemAmountEditorComponent } from './accounts-payable/apply-adjustment-debit/apply-debit-line-item-amount-editor/apply-debit-line-item-amount-editor.component';
import { WriteOffInvoicesComponent } from './account-receivable/write-off-invoices/write-off-invoices.component';
import { GLBatchSummaryComponent } from './general-ledger/gl-batch-summary/gl-batch-summary.component';
import { GLBatchDetailComponent } from './general-ledger/gl-batch-detail/gl-batch-detail.component';
import { RevenueManagementGlAccountSelectorComponent } from './revenue-management/revenue-management-gl-account-selector/revenue-management-gl-account-selector.component';
import { DimensionSelectorComponent } from './accounts-payable/ap-adjustment/dimension-selector/dimension-selector.component';
import { WriteOffInvoiceLineItemComponent } from './account-receivable/write-off-invoices/write-off-invoice-line-item/write-off-invoice-line-item.component';

@NgModule({
    declarations: [
        TransactionHistoryComponent,
        ARInvoiceDetailsComponent,
        WaiveInvoiceConfirmationComponent,
        AddressEditorComponent,
        APBillDetailComponent,
        ARAdjustmentComponent,
        TransactionAttachmentsComponent,
        APPaymentDetailsComponent,
        APAdjustmentComponent,
        CashReceiptDetailsComponent,
        CashReceiptsEditorComponent,
        CashReceiptReverseEditorComponent,
        DepositDetailsComponent,
        CBBatchDetailsComponent,
        ARPaymentDetailsComponent,
        ARPaymentTransferHistoryComponent,
        DetailPopupsComponent,
        ApplyVendorCreditsComponent,
        ChangeSpecialHandlingComponent,
        ARCreditApplicationComponent,
        ARPaymentReverseEditorComponent,
        ARPaymentEditorComponent,
        ARPaymentTransferEditorComponent,
        AddTransferAccountComponent,
        IssueRefundPaymentEditorComponent,
        VoidAPPaymentComponent,
        APPaymentPostDateEditorComponent,
        APAdjustmentEditorComponent,
        AccountSelectorComponent,
        ChangeVendorComponent,
        JournalEntryDetailComponent,
        ARManualLineItemCreditApplicationComponent,
        WriteOffInvoiceConfirmationComponent,
        ARInvoiceReverseEditorComponent,
        ARAdjustmentReverseEditorComponent,
        ARAdjustmentWriteOffEditorComponent,
        ARMiscInvoiceEditorComponent,
        ARInvoiceEditorComponent,
        ServiceChargeEditorComponent,
        ARManualCreditApplicationComponent,
        APReverseComponent,
        ARAdjustmentEditorComponent,
        APCreditApplicationComponent,
        ApplyAdjustmentDebitComponent,
        ApplyDebitLineItemAmountEditorComponent,
        WriteOffInvoicesComponent,
        GLBatchSummaryComponent,
        GLBatchDetailComponent,
        RevenueManagementGlAccountSelectorComponent,
        DimensionSelectorComponent,
        WriteOffInvoiceLineItemComponent
    ],
    imports: [
        CommonModule,
        CCCommonModule,
        CCDataGridFeaturesModule,
        DxBoxModule,
        DxDataGridModule,
        DxLoadPanelModule,
        DxDropDownBoxModule,
        DxDropDownButtonModule,
        DxPopupModule,
        DxFormModule,
        DxListModule,
        DxButtonModule,
        DxDateBoxModule,
        DxNumberBoxModule,
        DxTextBoxModule,
        DxTabPanelModule,
        DxTabsModule,
        DxTemplateModule,
        DxToolbarModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxTextAreaModule,
        DxContextMenuModule,
        DxLoadPanelModule,
        DxSwitchModule,
        AngularSplitModule,
        DxRadioGroupModule,
        DxPopoverModule,
        DxFileUploaderModule,
        DxCheckBoxModule,
        SharedModule,
        ManagementCommonModule,
        SharedWorkflowModule,
        DxTreeListModule
    ],
    exports: [
        ARInvoiceDetailsComponent,
        WaiveInvoiceConfirmationComponent,
        TransactionHistoryComponent,
        AddressEditorComponent,
        ARAdjustmentComponent,
        APPaymentDetailsComponent,
        APAdjustmentComponent,
        APBillDetailComponent,
        CashReceiptDetailsComponent,
        CashReceiptsEditorComponent,
        CashReceiptReverseEditorComponent,
        DepositDetailsComponent,
        CBBatchDetailsComponent,
        ARPaymentDetailsComponent,
        DetailPopupsComponent,
        ApplyVendorCreditsComponent,
        ChangeSpecialHandlingComponent,
        ARPaymentReverseEditorComponent,
        ARPaymentEditorComponent,
        ARPaymentTransferEditorComponent,
        APAdjustmentEditorComponent,
        AccountSelectorComponent,
        ChangeVendorComponent,
        JournalEntryDetailComponent,
        ARInvoiceReverseEditorComponent,
        ARAdjustmentReverseEditorComponent,
        ARAdjustmentWriteOffEditorComponent,
        ARMiscInvoiceEditorComponent,
        ARInvoiceEditorComponent,
        ServiceChargeEditorComponent,
        ARManualCreditApplicationComponent,
        ARManualLineItemCreditApplicationComponent,
        APReverseComponent,
        ARAdjustmentEditorComponent,
        IssueRefundPaymentEditorComponent,
        WriteOffInvoicesComponent,
        GLBatchSummaryComponent,
        GLBatchDetailComponent,
        RevenueManagementGlAccountSelectorComponent
    ]
})
export class SharedCirabooksModule {}
